const PreloadStatus = {
  NOT_STARTED: 'NOT_STARTED',
  WAITING_FOR_START: 'WAITING_FOR_START',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export default PreloadStatus;
